import { __rest } from "tslib";
import React from 'react';
import IconWrapper from '../IconWrapper';
const PlusOneIcon = (_a) => {
    var { id = 'plusone' } = _a, restProps = __rest(_a, ["id"]);
    return (React.createElement(IconWrapper, Object.assign({ viewBox: "1 1 24 24", role: "img", "aria-labelledby": id }, restProps),
        React.createElement("title", { id: id }, "1+"),
        React.createElement("circle", { cx: "13", cy: "13", r: "12", fill: "#D6001C", strokeWidth: "2" }),
        React.createElement("path", { d: "M10.172 18V11.088H8.23997L8.83997 9.6H11.708V18H10.172ZM19.2244 14.544H16.9564V16.836H15.4204V14.544H13.1524V13.056H15.4204V10.764H16.9564V13.056H19.2244V14.544Z", fill: "white" })));
};
export default PlusOneIcon;
//# sourceMappingURL=PlusOneIcon.js.map